import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { TESTIMONIALS, IMAGES } from "../../data";
import { ArrowLeft, ArrowRight } from "lucide-react";

const ease = [0.76, 0, 0.24, 1];

export const Testimonials = () => {
  const [i, setI] = useState(0);
  const [dir, setDir] = useState(1);
  const go = (d) => {
    setDir(d);
    setI((p) => (p + d + TESTIMONIALS.length) % TESTIMONIALS.length);
  };
  const t = TESTIMONIALS[i];

  return (
    <section id="brides" className="py-24 md:py-40" data-testid="testimonials-section">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 grid md:grid-cols-12 gap-12 md:gap-16 items-center">
        <div className="md:col-span-5 relative overflow-hidden aspect-[4/5] border border-line order-2 md:order-1">
          <img src={IMAGES.testimonial} alt="Real NK bride" className="w-full h-full object-cover object-top" />
        </div>

        <div className="md:col-span-6 md:col-start-7 order-1 md:order-2">
          <p className="text-xs uppercase tracking-[0.35em] text-champagne mb-8">Our Brides</p>
          <div className="min-h-[280px] md:min-h-[240px]">
            <AnimatePresence mode="wait" custom={dir}>
              <motion.blockquote
                key={i}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.6, ease }}
                data-testid="testimonial-quote"
              >
                <p className="font-serif font-light text-3xl md:text-4xl leading-[1.2] tracking-tight">
                  “{t.quote}”
                </p>
                <footer className="mt-8">
                  <p className="text-sm uppercase tracking-[0.2em]">{t.name}</p>
                  <p className="text-sm text-ink/50 mt-1 font-light">{t.place}</p>
                </footer>
              </motion.blockquote>
            </AnimatePresence>
          </div>

          <div className="flex items-center gap-6 mt-10">
            <button onClick={() => go(-1)} data-testid="testimonial-prev" className="w-12 h-12 border border-ink flex items-center justify-center hover:bg-ink hover:text-ivory transition-colors duration-400" aria-label="Previous">
              <ArrowLeft size={16} />
            </button>
            <button onClick={() => go(1)} data-testid="testimonial-next" className="w-12 h-12 border border-ink flex items-center justify-center hover:bg-ink hover:text-ivory transition-colors duration-400" aria-label="Next">
              <ArrowRight size={16} />
            </button>
            <span className="text-sm text-ink/40 ml-2">0{i + 1} — 0{TESTIMONIALS.length}</span>
          </div>
        </div>
      </div>
    </section>
  );
};
